export default "__VITE_ASSET__Q7aGhCMg__"